<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col cols="3" offset="5" class="pb-0 pt-0">
									<v-card-title class="text-center pa-2 pb-2 pt-0">
										{{ $t('titles.candidateDocuments') }}</v-card-title
									>
								</v-col>
								<v-col class="d-flex justify-end pa-0 pl-2">
									<v-btn color="primary" @click="addClick">
										<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addDocument') }}
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0 pb-0">
									<TheTable
										:additional-filters="candidateDocumentsTable.additionalFilters"
										:default-sort="candidateDocumentsTable.defaultSort"
										:excel="false"
										:fields="candidateDocumentsTable.headers"
										:header-selection-key="'candidate-documents-headers'"
										:height="candidateDocumentsTable.height"
										:total-records="candidateDocumentsTable.total"
										:filter-save-key="'candidate-documents-filters'"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in candidateDocumentsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
											@contextmenu.prevent="editClick(item.id)"
										>
											<td
												v-if="candidateDocumentsTable.selectedHeaders.includes('name')"
												@click="editClick(item.id)"
											>
												{{ item.name }}
											</td>
											<td
												v-if="candidateDocumentsTable.selectedHeaders.includes('updated_at')"
												@click="editClick(item.id)"
											>
												{{ item.updated_at }}
											</td>
											<td v-if="candidateDocumentsTable.selectedHeaders.includes('document')">
												<Upload
													:readonly="true"
													:showBorder="false"
													v-model="item.uploaded_file"
												></Upload>
											</td>
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															small
															v-bind="attrs"
															@click="deleteClick(item.id)"
															v-on="on"
														>
															<v-icon small>fas fa-trash</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.deleteDocument') }}</span>
												</v-tooltip>
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-col>
				<Modal :show-modal="showModal">
					<Document
						:documentId="selectedDocument"
						:inEditMode="true"
						@close="closeModal"
						@reloadData="reloadData(candidateDocumentsTable.lastRequest)"
					></Document>
				</Modal>
			</v-col>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Upload from '../../trinkets/Upload';
import Modal from '../../trinkets/Modal';
import Document from './Document';

export default {
	name: 'CandidateDocuments',
	components: { TheTable, Upload, Modal, Document },
	data: function () {
		return {
			candidateDocumentsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.name'), value: 'name', type: 'string', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.updatedAt'),
						value: 'updated_at',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.document'),
						value: 'document',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			showModal: false,
			selectedDocument: 0,
		};
	},
	methods: {
		addClick() {
			this.showModal = true;
			this.selectedDocument = 0;
		},
		closeModal() {
			this.showModal = false;
		},
		editClick(selectedDocument) {
			this.selectedDocument = selectedDocument;
			this.showModal = true;
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
				if (result) {
					vm.$APICall('delete', 'candidate-documents/' + id + '/delete', { id: id }, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.documentDeleteSuccess'));
							vm.reloadData(vm.candidateDocumentsTable.lastRequest);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		selectHeaders(headers) {
			this.candidateDocumentsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.candidateDocumentsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidate-documents/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.candidateDocumentsTable.items = data.items;
						vm.candidateDocumentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidateDocumentsTable.height = window.innerHeight - 320 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
